// @flow
import React from 'react';

import { Paragraph, Wrapper } from './styles';

const PayerSplashWelcomeText = ({ children, textAlign = 'left', paragraphs = [] }: any) => (
  <Wrapper textAlign={textAlign}>
    {paragraphs.map(p => (
      <Paragraph key={p}>{p}</Paragraph>
    ))}
    {children}
  </Wrapper>
);

export default PayerSplashWelcomeText;



// WEBPACK FOOTER //
// ./src/components/payer/splash/welcome-text/index.js